import styled, { keyframes } from 'styled-components/macro';
import { ReactComponent as Logo } from '../../../svgs/talk-english-logo.svg';
import {
  fontSize,
  layout,
  lineHeight,
  neutral,
  radius,
  space,
} from '../../../theme/tokens';
import { Button, ResetButton } from '../../common/elements/Form';

export const AuthContainer = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  gap: ${space[2]};
  width: 100%;
  min-height: calc(100vh - ${layout.mobileNavHeight} - 3rem);
  padding: 0 ${layout.gutter} ${space[5]};

  /* the shared ResetButton is full-viewport-wide with tiny text; tidy it up on the sign-in screen */
  ${ResetButton} {
    width: auto;
    min-height: ${layout.touchTarget};
    margin: 0;
    padding: 0 ${space[3]};
    font-size: ${fontSize.sm};
    line-height: ${lineHeight.tight};
    border-radius: ${radius.md};
    cursor: pointer;
  }

  /* privacy notice */
  & > p {
    max-width: ${layout.readableMaxWidth};
    margin: ${space[3]} 0 0;
    font-size: ${fontSize.sm};
    line-height: ${lineHeight.normal};
    text-align: center;
    color: ${neutral.textMuted};
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ToggleSignUpInButton = styled(Button).attrs(({ $variant }) => ({
  $variant: $variant || 'lesson',
}))`
  margin-top: ${space[4]};
`;

export const TalkEnglishLogo = styled(Logo)`
  /* logo size */
  min-height: 3rem;
`;

export const PNGLogo = styled.img`
  /* partner logo size */
  height: 5rem;
  margin-top: ${space[3]};
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Fullscreen = styled.main`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  animation: ${fadeIn} 1s linear;
`;

export * from '../../common/elements/Form';
